export enum TypeOrder {
  None = 0,
  Count = 1
}
